(function() { window.GUID_021c023c_b522_4fab_a8e2_d62058336af6 = { getGuid: function() { return "021c023c-b522-4fab-a8e2-d62058336af6"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class BracketHeader {
            constructor(bracket, sectionNumber) {
                let me = this;
                me.exist = false;
                me.sectionNumber = sectionNumber;
                this.bracket = bracket;
                this.$Header = this.bracket.$Control.find('.bracket__section-header.s-' + sectionNumber);
            }
        }
        Controls.BracketHeader = BracketHeader;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=bracket-header.js.map
